/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPhoneSmartIcon64Regular = forwardRef('TechPhoneSmartIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M22.5 48.5A1.5 1.5 0 0 1 24 47h15a1.5 1.5 0 0 1 0 3H24a1.5 1.5 0 0 1-1.5-1.5Z" }),
        React.createElement("path", { d: "M23 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 16.5C11 10.701 15.701 6 21.5 6h21C48.299 6 53 10.701 53 16.5v31C53 53.299 48.299 58 42.5 58h-21C15.701 58 11 53.299 11 47.5v-31ZM21.5 9a7.5 7.5 0 0 0-7.5 7.5v31a7.5 7.5 0 0 0 7.5 7.5h21a7.5 7.5 0 0 0 7.5-7.5v-31A7.5 7.5 0 0 0 42.5 9h-21Z" })));
});
